import { MDText } from 'i18n-react';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { titleCaseFirstLetter } from 'Utilities';
import { SORTED_LOCATION_PAGES } from 'Utilities/locations';

import { ComponentContent, CONTENT_SIZES } from 'Layout';

import LocalTexts from './Locations.json';

import styles from './Locations.module.scss';

const LocalT = new MDText(LocalTexts);

export default () => (
  <ComponentContent className={styles.component} maxWidth={CONTENT_SIZES.container}>
    <h2>{LocalT.translate('title')}</h2>
    <p>{LocalT.translate('strap')}</p>
    <ul>
      {
        SORTED_LOCATION_PAGES.map((location) => (
          <li key={location}>
            <Hyperlink
              key={location}
              href={`/sell-your-car/${location}`}
              label={titleCaseFirstLetter(location)}
            />
          </li>
        ))
      }
    </ul>
  </ComponentContent>
);
